<div
    [attr.data-testid]="id + '-container'"
    [attr.data-styletarget]="'iq-social-links-podcast__container'"
>
    @for(podcast of podcasts; track podcast.url) {
    <div
        class="text-dat-grey-900 font-body-2 flex align-center h-[20px] mt-[10px] mb-2 pb-4 pt-4"
        [attr.data-testid]="id + '-body' + '-' + podcast.label"
        [attr.data-styletarget]="'iq-social-links-podcast__body'"
    >
        <span>{{ podcast.label }}</span>
        <a
            [href]="podcast.url"
            target="_blank"
            class="ml-2 h-[1px]"
            [attr.data-testid]="id + '-link' + '-' + podcast.label"
            [attr.data-styletarget]="'iq-social-links-podcast__link'"
            (click)="onClick(podcast.url)"
        >
            <span
                class="material-symbols-outlined h-[20px] w-[20px] leading-[20px] text-dat-grey-900"
                [attr.data-testid]="id + '-icon' + '-' + podcast.label"
                [attr.data-styletarget]="'iq-social-links-podcast__icon'"
            >
                open_in_new
            </span>
        </a>
    </div>
    @if(!$last) {
    <div
        class="pt-4 border-b-[1px] border-x-0 border-t-0 border-solid border-dat-grey-100"
        [attr.data-testid]="
            'iq-social-links-podcast-link-border-' + podcast.label
        "
    ></div>
    } }
</div>
